import React from "react"
import styled from "@emotion/styled"
import { Box, Flex } from "theme-ui"
import { Link } from "gatsby"

const BlueBox = styled.div`
    background-color: ${(props) => props.theme.colors.light_blue_2};
    bottom: 3rem;
    height: auto;
    border-radius: 1rem;
    margin-bottom: 1rem;
    padding: 2rem 1.5rem;

    & p {
        padding: 0 2rem;
        color: ${(props) => props.theme.colors.primary};
    }
    & a {
        background: ${(props) => props.theme.colors.light_blue_1};
        border-radius: 2rem;
        margin-top: 0.5rem;
        padding: 0.7rem 1.4rem;
        color: #ffffff;
        text-decoration: none;

        &:hover {
            text-decoration: none;
        }
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        padding: 1rem 0.5rem;
        & div {
            // flex-direction: column;
        }
        & a {
            padding: 0.5rem 1rem;
        }
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[3]}) {
        padding: 0.5rem 0;
    }
`

const HighlightText = styled.span`
    color: ${(props) => props.theme.colors.primary};
    font-weight: bold;
`

const Cards = ({ url, slug, title, emp_type, submit }) => {
    url = url.split("/").filter(x => x).join("/")
    return (
        <BlueBox>
            <Flex sx={{ alignItems: "center" }}>
                <Box sx={{flex: "0 0 50%"}}>
                    <p>
                        <HighlightText>{title}</HighlightText>
                        <br />
                        <small>{emp_type.replace("_", " ")}</small>
                    </p>
                </Box>
                <Box
                    sx={{
                        padding: "1rem",
                        marginLeft: "auto",
                    }}
                >
                    <Link to={`/${url}/${slug}`} className="content-paragraph">
                        {submit === true ? "Apply Now" : "Read More"}
                    </Link>
                </Box>
            </Flex>
        </BlueBox>
    )
}

export default Cards
